import axios from 'axios'

export const LOCATION_URL = `${process.env.REACT_APP_API_URL}/location`

export const getLocations = async (skip = 0, take = 10, sort?: any, filter?: any) => {
  let sortString = ''
  if (sort && sort.field && sort.dir) {
    sortString = `${sort.field} ${sort.dir}`
  }
  const response = await axios.post(`${LOCATION_URL}/getlocations`, {
    skip,
    take,
    sort: sortString,
    filter
  })
  return response
}

export const syncLocations = async () => {
  // POST to /location/sync endpoint
  return axios.post(`${LOCATION_URL}/sync`)
}
